import { Component, OnInit ,effect, inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
    selector: 'taly-account-created',
    templateUrl: './account-created.component.html',
    styleUrls: ['./account-created.component.scss'],
    standalone: false
})

export class AccountCreatedComponent implements OnInit{

  transferSignal = inject(SharedSignalsService);
  
  constructor(private router: Router, private activatedRoute: ActivatedRoute){}

  ngOnInit(): void {
    this.transferSignal.setHeader(false);
    setTimeout(() => {

      if(this.transferSignal?.orderStatus() != "INITIATED"){
        this.router.navigate(['../payment/error'],{ relativeTo: this.activatedRoute });
      }else{
        this.router.navigate(['../payment-method'], { relativeTo: this.activatedRoute });
      }

      
    }, 3000);
    
  }
  ngOnDestroy(){
    this.transferSignal.setHeader(true);
  }
}
